import { useContext, useEffect, useState } from 'react';
import { Table, Button, Space } from 'antd';
import MainCard from 'components/MainCard';

import { deleteInspection, getInspectionByPagination } from '../../utils/api';
import { useNavigate } from 'react-router';
import { BASE_API_URL, DOWNLOAD_PDF_URL, MASTER_PAGE } from '../../config';

import { UserContext } from '../../contexts/UserContext';
import ModalConfirm from './ModalConfirm';
import { formatGraceEndDate, getSubscriptionAccess } from '../../utils/subscription';
export default function InspectionList() {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [loading, setLoading] = useState(false);
    const { showToast, user } = useContext(UserContext);
const navigate = useNavigate();
 const subscriptionAccess = getSubscriptionAccess(user);
 const graceEndDate = formatGraceEndDate(user?.limits?.inspection_expiry_date ?? user?.inspection_expiry_date);
 const fetchData = async (page = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const response = await getInspectionByPagination({ page, limit: pageSize }); // pass pagination params
      const result = response.data;

      setData(result.data); // ✅ array of inspections
      setPagination({
        current: result.current_page,
        pageSize: result.per_page,
        total: result.total,
      });
    } catch (error) {
      console.error('Failed to fetch inspection list:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize);
  }, []);

  const handleTableChange = (pagination) => {
    fetchData(pagination.current, pagination.pageSize);
  };
const gotoInspectionForm = (record) => {
  if (user?.role === 'user' && !subscriptionAccess.canCreateInspection) {
    const msg =
      subscriptionAccess.phase === 'grace' && graceEndDate
        ? `Subscription expired. You can view reports until ${graceEndDate}, but cannot add new inspections.`
        : 'Subscription expired. You cannot add new inspections.';
    showToast(msg, 'error');
    return;
  }
  navigate(`${MASTER_PAGE}${record.id}`, { state: { record } });
};
  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70 },
    { title: 'Equipment No', dataIndex: 'equipment_no', key: 'equipment_no' },
    { title: 'Customer Name', dataIndex: 'customer_name', key: 'customer_name' },
    { title: 'Plant Location', dataIndex: 'plant_location', key: 'plant_location' },
    { title: 'Inspection Date', dataIndex: 'inspection_date', key: 'inspection_date' },
    { title: 'Notes', dataIndex: 'notes', key: 'notes' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
        <Button type="link" onClick={() => gotoInspectionForm(record)} disabled={user?.role === 'user' && !subscriptionAccess.canCreateInspection}>
          Add Inspection
        </Button>
      <Button type="link" onClick={() => downloadZipfromDB(record)}>
        Download Chart
      </Button>         
         {/* <Button type="link" onClick={() => handleDelete(record)}>Delete</Button>  */}
         <ModalConfirm btnText={"Delete"} 
         data={record} handleDelete={handleDelete}
         msg={'Inspection ID '}
         />
        </Space>
      ),
    },
  ];

const downloadZipfromDB = async (record) => {
  try {
    if (user?.role === 'user' && !subscriptionAccess.canViewReports) {
      showToast('Your subscription grace period is over. Please contact your admin.', 'error');
      return;
    }
    if(!record.pdf_path)
    {
      showToast('No chart file available', 'error');
     return
    }
      
    window.location.href = `${BASE_API_URL}${DOWNLOAD_PDF_URL}${record.pdf_path}`
     showToast('Zip file downloaded..', 'info');
    
  } catch (error) {
    console.error('Download failed:', error);
  }
};


const handleDelete = async (record) => {
 
      try {
        // TODO: Replace with actual delete API call
        console.log('Deleting:', record);
        await deleteInspection(record.enc_id)
        showToast(`Inspection ID ${record.id} deleted`, 'success');
        fetchData(pagination.current, pagination.pageSize); // refresh list
      } catch (error) {
        console.error('Delete failed:', error);
        showToast('Failed to delete inspection', 'error');
      }
   
  
};


  return (
    <MainCard title="Inspection List">
      {/* <Typography.Paragraph>
        Below is the list of inspections with pagination and actions.
      </Typography.Paragraph> */}
    
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
        scroll={{ x: 'max-content' }}  // This enables horizontal scroll + fixed columns
      />
    </MainCard>
  );
}
